module.exports = __webpack_public_path__ + "static/6-c9fc3ab10197ec863f1cb40ab0a8240c.png";